var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5247_6912",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.940918,
    y: 0.0429688,
    width: 28.0644,
    height: 28.0644,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5247_6912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9733 12.9056C17.8966 12.9056 20.3815 12.4476 22.4279 11.5316C24.4742 10.6156 25.4974 9.51447 25.4974 8.22819C25.4974 6.9419 24.4742 5.84076 22.4279 4.92477C20.3815 4.00878 17.8966 3.55078 14.9733 3.55078C12.0499 3.55078 9.56501 4.00878 7.51864 4.92477C5.47228 5.84076 4.4491 6.9419 4.4491 8.22819C4.4491 9.51447 5.47228 10.6156 7.51864 11.5316C9.56501 12.4476 12.0499 12.9056 14.9733 12.9056ZM14.9733 15.829C15.7723 15.829 16.7711 15.7461 17.9697 15.5805C19.1683 15.4148 20.323 15.1469 21.4339 14.7766C22.5448 14.4063 23.4998 13.9239 24.2988 13.3295C25.0979 12.7351 25.4974 12.0091 25.4974 11.1516V14.0749C25.4974 14.9325 25.0979 15.6584 24.2988 16.2529C23.4998 16.8473 22.5448 17.3296 21.4339 17.6999C20.323 18.0702 19.1683 18.3382 17.9697 18.5039C16.7711 18.6695 15.7723 18.7524 14.9733 18.7524C14.1742 18.7524 13.1754 18.6695 11.9768 18.5039C10.7782 18.3382 9.62348 18.0702 8.51259 17.6999C7.40171 17.3296 6.44674 16.8473 5.64768 16.2529C4.84863 15.6584 4.4491 14.9325 4.4491 14.0749V11.1516C4.4491 12.0091 4.84863 12.7351 5.64768 13.3295C6.44674 13.9239 7.40171 14.4063 8.51259 14.7766C9.62348 15.1469 10.7782 15.4148 11.9768 15.5805C13.1754 15.7461 14.1742 15.829 14.9733 15.829ZM14.9733 21.6757C15.7723 21.6757 16.7711 21.5929 17.9697 21.4272C19.1683 21.2616 20.323 20.9936 21.4339 20.6233C22.5448 20.253 23.4998 19.7707 24.2988 19.1762C25.0979 18.5818 25.4974 17.8559 25.4974 16.9983V19.9217C25.4974 20.7792 25.0979 21.5052 24.2988 22.0996C23.4998 22.694 22.5448 23.1764 21.4339 23.5467C20.323 23.917 19.1683 24.185 17.9697 24.3506C16.7711 24.5163 15.7723 24.5991 14.9733 24.5991C14.1742 24.5991 13.1754 24.5163 11.9768 24.3506C10.7782 24.185 9.62348 23.917 8.51259 23.5467C7.40171 23.1764 6.44674 22.694 5.64768 22.0996C4.84863 21.5052 4.4491 20.7792 4.4491 19.9217V16.9983C4.4491 17.8559 4.84863 18.5818 5.64768 19.1762C6.44674 19.7707 7.40171 20.253 8.51259 20.6233C9.62348 20.9936 10.7782 21.2616 11.9768 21.4272C13.1754 21.5929 14.1742 21.6757 14.9733 21.6757Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasters);
export default __webpack_public_path__ + "static/media/masters.5ecbb2e592146e83aa45ddde8cb0d616.svg";
export { ForwardRef as ReactComponent };